import React from 'react';

import { connect } from 'react-redux';

import Carousel from '@hpstellar/core/Carousel';
import ModalFooterV2 from './modal-footer-v2';
import Icon from '../../ui/components/icon';
import { updateCart } from '../../utility/utility-actions';

import '../css/purchase-summary.less';

const getControls = {
    slidesToShow: 2.5,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 1.75,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 850,
            settings: {
                slidesToShow: 1.1,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1.2,
                slidesToScroll: 1,
                arrows: false,
            },
        },
    ],
};

const ProductBlock = ({ product, enableRemove, updateCart, cartItems, handleRemove, className }) => {
    const remove = product => {
        const itemToRemove = cartItems.filter(item => item.pNum === product.sku)[0] || {};
        const quantityToRemove = (itemToRemove || {}).qty - 1 || 0;
        updateCart(itemToRemove, quantityToRemove).then(() => {
            handleRemove('remove', product.sku);
        });
    };

    return (
        <div className={`product-block-wrapper${className ? ' ' + className : ''}`}>
            <img src={product.imageUrl} />
            <h3>{product.name}</h3>
            {enableRemove && (
                <button className="remove" onClick={() => remove(product)}>
                    <Icon name="x" size={14} />
                </button>
            )}
        </div>
    );
};

const mapStateToProps = state => ({
    cartItems: state.cartInfo.items,
});

const mapDispatchToProps = dispatch => {
    return {
        updateCart: (cartItem, curQty) => dispatch(updateCart(cartItem, curQty)),
    };
};

const ConnectedProductBlock = connect(mapStateToProps, mapDispatchToProps)(ProductBlock);

const PurchaseSummary = ({ products, handleRemove, closeModal, device, width }) => {
    return products && products.length > 0 ? (
        <div className="xsell-modal-purchase-summary">
            <Carousel
                className="purchase-summary-carousel"
                prevArrowClassName="purchase-summary-prev"
                nextArrowClassName="purchase-summary-next"
                {...getControls}
            >
                {products.map((product, i) => (
                    <ConnectedProductBlock
                        key={product.sku}
                        product={product}
                        handleRemove={handleRemove}
                        enableRemove={i !== products.length - 1}
                        className={i === products.length - 1 ? ' last' : ''}
                    />
                ))}
            </Carousel>
            {width > 768 && (
                <ModalFooterV2
                    closeModal={closeModal}
                    className="tabs-v2"
                    cartBtnText="go to cart"
                    cartBtnMobileText="go to cart"
                    backBtnMobileText="continue shopping"
                    backBtnText="continue shopping"
                    device={device}
                />
            )}
        </div>
    ) : null;
};

export default PurchaseSummary;
